/* istanbul ignore file */
/* tslint:disable */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, boolean as codecBoolean, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { Assignment, AssignmentFeedback, AssignmentGrader, AssignmentPeerFeedbackConnection, AssignmentPeerFeedbackSettings, AssignmentTemplate, AssignmentTimeframes, AutoTest, CommentBase, CopyRubricAssignmentData, ExportAssignmentData, ExtendedCourse, ExtendedWork, ImportIntoAssignmentData, Job, PatchAssignmentData, PatchRubricCategoryTypeAssignmentData, PatchSubmitTypesAssignmentData, PlagiarismRun, PutDescriptionAssignmentData, PutRubricAssignmentData, RubricRowBase, UpdatePeerFeedbackSettingsAssignmentData, UploadSubmissionAssignmentData, WebhookBase, Work, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function assignment(config) {
    const putRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const deleteRubricResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const patchRubricCategoryTypeResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(RubricRowBase)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Assignment)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Assignment)),
    });
    const deleteDescriptionResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getDescriptionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    const putDescriptionResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const deleteTemplateResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getTemplateResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(AssignmentTemplate)),
    });
    const disablePeerFeedbackResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const updatePeerFeedbackSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(AssignmentPeerFeedbackSettings)),
    });
    const exportResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Job)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Assignment))),
    });
    const getAllGradersResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(AssignmentGrader))),
    });
    const getSubmissionsByUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(ExtendedWork))),
    });
    const getAllSubmissionsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([
            /* #__PURE__ */ codecArray(ExtendedWork),
            /* #__PURE__ */ codecArray(Work),
        ]))),
    });
    const getTemplateFileResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    const getTimeframesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(AssignmentTimeframes)),
    });
    const putTimeframesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(AssignmentTimeframes)),
    });
    const getAllFeedbackResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codec.record(codecString, AssignmentFeedback))),
    });
    const getAutoTestResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(AutoTest)),
    });
    const getCommentsByUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CommentBase))),
    });
    const getCourseResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(ExtendedCourse)),
    });
    const getWebhookSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(WebhookBase)),
    });
    const getMemberStatesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codec.record(codecString, codecBoolean))),
    });
    const getPeerFeedbackSubjectsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecArray(AssignmentPeerFeedbackConnection))),
    });
    const getAllPlagiarismRunsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(PlagiarismRun))),
    });
    const importIntoResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Assignment)),
    });
    const copyRubricResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RubricRowBase))),
    });
    const markGraderAsDoneResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const markGraderAsNotDoneResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const patchSubmitTypesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Assignment)),
    });
    const uploadSubmissionResponse = /* #__PURE__ */ makeResponses({
        201: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(ExtendedWork)),
    });
    return Object.freeze({
        /**
         * Add or update rubric of an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns The updated or created rubric.
         */
        putRubric: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/rubrics/`, putRubricResponse.v, JSON.stringify(PutRubricAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the rubric for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the `Assignment` whose rubric should be deleted.
         * @returns Nothing.
         */
        deleteRubric: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/rubrics/`, deleteRubricResponse.v, undefined);
            return result;
        },
        /**
         * Return the rubric corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns A list of `RubricRow` items.
         */
        getRubric: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/rubrics/`, getRubricResponse.v, undefined);
            return result;
        },
        /**
         * Change the type of a rubric category.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment of the rubric category.
         * @param arg.rubricCategoryId The rubric category you want to change the type of.
         * @param arg.requestBody The body of the request.
         * @returns The updated rubric row.
         */
        patchRubricCategoryType: async ({ assignmentId, rubricCategoryId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}/rubrics/${rubricCategoryId}/type`, patchRubricCategoryTypeResponse.v, JSON.stringify(PatchRubricCategoryTypeAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Delete a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @returns Nothing.
         */
        delete: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a single assignment by id.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment you want to get.
         * @returns The requested assignment.
         */
        get: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Update the given assignment with new values.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment you want to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment.
         */
        patch: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}`, patchResponse.v, JSON.stringify(PatchAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Deletes the description for a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns An empty response.
         */
        deleteDescription: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/description`, deleteDescriptionResponse.v, undefined);
            return result;
        },
        /**
         * Get the description for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @returns A public link that allows users to download the file or the file itself as a stream of octets
         */
        getDescription: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/description`, getDescriptionResponse.v, undefined);
            return result;
        },
        /**
         * Stores a file containing the new description for a given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns An empty response.
         */
        putDescription: async ({ assignmentId, requestBody, }) => {
            const body = coreUtils.toFormData(PutDescriptionAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/description`, putDescriptionResponse.v, body);
            return result;
        },
        /**
         * Delete the template corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns Nothing.
         */
        deleteTemplate: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/template`, deleteTemplateResponse.v, undefined);
            return result;
        },
        /**
         * Return the template corresponding to the given `assignment_id`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @returns The template for this assignment.
         */
        getTemplate: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/template`, getTemplateResponse.v, undefined);
            return result;
        },
        /**
         * Disabled peer feedback for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to disable peer feedback.
         * @returns Nothing; an empty response.
         */
        disablePeerFeedback: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/peer_feedback_settings`, disablePeerFeedbackResponse.v, undefined);
            return result;
        },
        /**
         * Enable peer feedback for an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to enable peer feedback.
         * @param arg.requestBody The body of the request.
         * @returns The just created peer feedback settings.
         */
        updatePeerFeedbackSettings: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/peer_feedback_settings`, updatePeerFeedbackSettingsResponse.v, JSON.stringify(UpdatePeerFeedbackSettingsAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Generate a CSV report for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @returns A CSV report for this assignment.
         */
        export: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/export`, exportResponse.v, JSON.stringify(ExportAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Get all the assignments that the current user can see.
         *
         * @param arg The arguments to the function.
         * @param arg.onlyWithRubric When `True` only assignments that have a rubric will be returned.
         * @returns All assignments (with a rubric if specified) that the current user can see.
         */
        getAll: async ({ onlyWithRubric = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/`, getAllResponse.v, undefined, {
                only_with_rubric: onlyWithRubric,
            });
            return result;
        },
        /**
         * Gets a list of all users that can grade in the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @returns A response containing the JSON serialized graders.
         */
        getAllGraders: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/graders/`, getAllGradersResponse.v, undefined);
            return result;
        },
        /**
         * Return all submissions by the given user in the given assignment.
         *
         * This always returns extended version of the submissions.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.userId The user of which you want to get the submissions.
         * @returns A response containing the JSON serialized submissions.
         */
        getSubmissionsByUser: async ({ assignmentId, userId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/submissions/`, getSubmissionsByUserResponse.v, undefined);
            return result;
        },
        /**
         * Return all submissions for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.extended Whether to get extended or normal submissions.
         * @param arg.latestOnly Only get the latest submission of a user. Please use this option if at all possible, as students have a tendency to submit many attempts and that can make this route quite slow. The default value was changed to `True` in version "O".
         * @returns A response containing the JSON serialized submissions.
         */
        getAllSubmissions: async ({ assignmentId, extended = undefined, latestOnly = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/submissions/`, getAllSubmissionsResponse.v, undefined, {
                extended,
                latest_only: latestOnly,
            });
            return result;
        },
        /**
         * Get the content of a single file of an assignment template.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment.
         * @param arg.fileId The id of the file.
         * @returns The contents of the requested file.
         */
        getTemplateFile: async ({ assignmentId, fileId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/template/${fileId}`, getTemplateFileResponse.v, undefined);
            return result;
        },
        /**
         * Get the schedule for the specified `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @returns The assignment schedule.
         */
        getTimeframes: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/timeframes/`, getTimeframesResponse.v, undefined);
            return result;
        },
        /**
         * Updates the schedule for the specified `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment;
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment schedule.
         */
        putTimeframes: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/assignments/${assignmentId}/timeframes/`, putTimeframesResponse.v, JSON.stringify(AssignmentTimeframes.encode(requestBody)));
            return result;
        },
        /**
         * Get all feedbacks for all the latest submissions for a given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment to query for.
         * @returns A mapping between the id of the submission and a `AssignmentFeeback` object.
         */
        getAllFeedback: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/feedbacks/`, getAllFeedbackResponse.v, undefined);
            return result;
        },
        /**
         * Get the `AutoTest` for this assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment from which you want to get the `AutoTest`.
         * @returns The `AutoTest` for the given assignment, if it has an `AutoTest`.
         */
        getAutoTest: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/auto_test`, getAutoTestResponse.v, undefined);
            return result;
        },
        /**
         * Get all the comments threads that a user replied on.
         *
         * This route is especially useful in the context of peer feedback. With this route you can get all the comments placed by the student, so you don't have to get all the submissions (including old ones) by the peer feedback subjects.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment from which you want to get the threads.
         * @param arg.userId The id of the user from which you want to get the threads.
         * @returns A list of comments that all have at least one reply by the given user. There might be replies missing from these bases if these replies where not given by the user with id `user_id`, however no guarantee is made that all replies are by the user with id `user_id`.
         */
        getCommentsByUser: async ({ assignmentId, userId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/comments/`, getCommentsByUserResponse.v, undefined);
            return result;
        },
        /**
         * Get the course connected to an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment from which you want to get the course.
         * @returns A response containing the JSON serialized course.
         */
        getCourse: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/course`, getCourseResponse.v, undefined);
            return result;
        },
        /**
         * Create or get the webhook settings to hand-in submissions.
         *
         * You can select the user for which the webhook should hand-in using the exact same query parameters as the route to upload a submission.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment for which the webhook should hand-in submissions.
         * @param arg.webhookType The webhook type, currently only `git` is supported, which works for both GitLab and GitHub.
         * @param arg.authorId The id of the user for which we should get the webhook settings. If not given defaults to the current user.
         * @param arg.isTestSubmission Should we get the webhook settings for the test student.
         * @returns A serialized form of a webhook, which contains all data needed to add the webhook to your provider.
         */
        getWebhookSettings: async ({ assignmentId, webhookType, authorId = undefined, isTestSubmission = undefined, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/webhook_settings`, getWebhookSettingsResponse.v, undefined, {
                webhook_type: webhookType,
                author_id: authorId,
                is_test_submission: isTestSubmission,
            });
            return result;
        },
        /**
         * Get the LTI states for the members of a group for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The assignment for which the LTI states should be given.
         * @param arg.groupId The group for which the states should be returned.
         * @returns A mapping between user id and a boolean indicating if we can already passback grades for this user. If the assignment is any LTI assignment and any of the values in this mapping is `False` trying to submit anyway will result in a failure.
         */
        getMemberStates: async ({ assignmentId, groupId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/groups/${groupId}/member_states/`, getMemberStatesResponse.v, undefined);
            return result;
        },
        /**
         * Get the peer feedback subjects for a given user.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment in which you want to get the peer feedback subjects.
         * @param arg.userId The id of the user from which you want to retrieve the peer feedback subjects.
         * @returns The peer feedback subjects. If the deadline has not expired, or if the assignment is not a peer feedback assignment an empty list will be returned.
         */
        getPeerFeedbackSubjects: async ({ assignmentId, userId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/users/${userId}/peer_feedback_subjects/`, getPeerFeedbackSubjectsResponse.v, undefined);
            return result;
        },
        /**
         * Get all plagiarism runs for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @returns A response containing the JSON serialized list of plagiarism runs.
         */
        getAllPlagiarismRuns: async ({ assignmentId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/assignments/${assignmentId}/plagiarism/`, getAllPlagiarismRunsResponse.v, undefined);
            return result;
        },
        /**
         * Import an assignment into another assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.intoAssignmentId The assignment you want to import into.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment, so the assignment which was imported into.
         */
        importInto: async ({ intoAssignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${intoAssignmentId}/import`, importIntoResponse.v, JSON.stringify(ImportIntoAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Import a rubric from a different assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment in which you want to import the rubric. This assignment shouldn't have a rubric.
         * @param arg.requestBody The body of the request.
         * @returns The rubric rows of the assignment in which the rubric was imported, so the assignment with id `assignment_id` and not `old_assignment_id`.
         */
        copyRubric: async ({ assignmentId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/rubric`, copyRubricResponse.v, JSON.stringify(CopyRubricAssignmentData.encode(requestBody)));
            return result;
        },
        /**
         * Indicate that the given grader is done grading the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment the grader is done grading.
         * @param arg.graderId The id of the `User` that is done grading.
         * @returns An empty response with return code 204
         */
        markGraderAsDone: async ({ assignmentId, graderId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/graders/${graderId}/done`, markGraderAsDoneResponse.v, undefined);
            return result;
        },
        /**
         * Indicate that the given grader is not yet done grading the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment the grader is not yet done grading.
         * @param arg.graderId The id of the `User` that is not yet done grading.
         * @returns An empty response with return code 204
         */
        markGraderAsNotDone: async ({ assignmentId, graderId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/assignments/${assignmentId}/graders/${graderId}/done`, markGraderAsNotDoneResponse.v, undefined);
            return result;
        },
        /**
         * Update the given assignment editor template with new files.
         *
         * How this route deals with existing editor templates when submitting is still experimental and might change in an upcoming release.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment for which you want to update the editor template.
         * @param arg.requestBody The body of the request.
         * @returns The updated assignment.
         */
        patchSubmitTypes: async ({ assignmentId, requestBody, }) => {
            const body = coreUtils.toFormData(PatchSubmitTypesAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'PATCH', `/api/v1/assignments/${assignmentId}/submit_types`, patchSubmitTypesResponse.v, body);
            return result;
        },
        /**
         * Upload one or more files as `Work` to the given `Assignment`.
         *
         * @param arg The arguments to the function.
         * @param arg.assignmentId The id of the assignment
         * @param arg.requestBody The body of the request.
         * @param arg.authorId The id of the user for which we should get the webhook settings. If not given defaults to the current user.
         * @param arg.isTestSubmission Should we get the webhook settings for the test student.
         * @param arg.ignoredFiles How to handle ignored files. The options are: `keep`: this the default, sipmly do nothing about ignored files. `delete`: delete the ignored files. `error`: return an error when there are ignored files in the archive.
         * @returns The created work.
         */
        uploadSubmission: async ({ assignmentId, requestBody, authorId = undefined, isTestSubmission = undefined, ignoredFiles = undefined, }) => {
            const body = coreUtils.toFormData(UploadSubmissionAssignmentData.encode(requestBody));
            const result = await requestParams(config, 'POST', `/api/v1/assignments/${assignmentId}/submission`, uploadSubmissionResponse.v, body, {
                author_id: authorId,
                is_test_submission: isTestSubmission,
                ignored_files: ignoredFiles,
            });
            return result;
        },
    });
}
